/*
These sizes are to support messaging configurator consistent experience for any base font size set at the root (html) level
*/
export const Sizes = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  '2xl': '32px',
  '3xl': '48px',
  '4xl': '72px'
};

export const FontSizes = {
  small: '0.75rem',
  normal: '.875rem',
  large: '1rem'
};

export const BottomMarginLarge = `0 0 ${Sizes.lg} 0`;
